<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Sonnenschein"
      question2="Blumenduft"
      question3="Lebensfreude"
      claim="Prima! Dann hilf uns dabei, Freude zu verbreiten und die Welt zu einem besseren Ort zu machen."
      solution="Ein erster Schritt dazu kann sein, deinen Liebsten ein Lächeln ins Gesicht zu zaubern und ihnen zu sagen: Ich denke an dich! Mit unseren Blühpatenschaften erreichst du aber noch viel mehr: Du sorgst dafür, dass bedrohte Insekten wie die Wildbiene ein neues Zuhause bekommen und unser Land in neuer Farbenpracht erstrahlt."
    />
    <textblock
      headline="Verschenke jetzt Freude mit einer Blühpatenschaft!"
      column1="Kennst du das auch, wenn du automatisch lächeln musst, wenn du Blumen in ihrer vollen Blüte entdeckst? Egal, wie herausfordernd unser Alltag manchmal auch sein mag – Blumen bringen Freude und ein Spaziergang durch die Natur versorgt uns mit neuer Energie. Das ist sogar wissenschaftlich erwiesen. Mit einer Blühpatenschaft von der Wilden Pracht verschenkst du Blumen, die genau dort bleiben, wo sie den Menschen und Tieren am längsten Freude bereiten – auf dem Feld! Dort wächst und gedeiht die Wilde Pracht und blüht auch in vielen Wochen noch!"
      column2="In der kompletten Blühsaison, für die du die Patenschaft erwirbst, halten wir dich mit unserer Bienenpost darüber auf dem Laufenden, was auf dem Acker passiert. Du erfährst, wenn die Samen verteilt und die ersten zarten Pflänzchen ihr Köpfe in den Himmel strecken. Und natürlich, wenn der Blühstreifen in Wilder Pracht erstrahlt. Wenn du deinen Liebsten jetzt eine Freude machen möchtest, ist das ganz leicht: Fülle direkt unten in drei einfachen Schritten unser Formular aus und sofort kannst du dir deine Blühkarte herunterladen, die anschließend zusätzlich per Post zu dir nach Hause kommt."
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und verschenke Freude und Wilde Pracht!"
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Corona",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform
  },
  metaInfo: {
    title: "Magst du Lebensfreude? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Zeige deinen Liebsten, dass du auch in schwierigen Zeiten an sie denkst und überrasche sie mit einer Blühpatenschaft."
      },
      { itemprop: "name", content: "Magst du Lebensfreude? | Wilde Pracht" },
      {
        property: "og:title",
        content: "Magst du Lebensfreude? | Wilde Pracht"
      },
      {
        itemprop: "description",
        content:
          "Zeige deinen Liebsten, dass du auch in schwierigen Zeiten an sie denkst und überrasche sie mit einer Blühpatenschaft."
      },
      {
        property: "og:description",
        content:
          "Zeige deinen Liebsten, dass du auch in schwierigen Zeiten an sie denkst und überrasche sie mit einer Blühpatenschaft."
      }
    ]
  }
};
</script>

<style lang="scss"></style>
